<ng-container *ngIf="!isMobile; else mobileNav">
  <ng-container *ngTemplateOutlet="defaultNav"></ng-container>
  <ng-container *ngTemplateOutlet="steppers"></ng-container>
</ng-container>

<ng-template #mobileNav>
  <ng-container *ngTemplateOutlet="collapsedNav"></ng-container>
</ng-template>

<ng-template #collapsedNav>
  <div class="hidden" [class.has-sidebar]="sidebarState === sidebar.Stepper">
    <div class="collapsed-nav">
      <div
        class="collapsed-nav-icon"
        (click)="handleOnClickCollapseNav()"
      ></div>
      <div>Step {{ currentStep }} of {{ totalStep }}</div>
    </div>
    <div
      class="mobile-steppers"
      [class.show-mobile-stepper]="isMobileStepperSideBarOpened"
      [clickOutsideEnabled]="isMobileStepperSideBarOpened"
      (clickOutside)="handleOnClickOutsideCollapseNav()"
      [exclude]="'.collapsed-nav-icon'"
    >
      <div>
        <ng-container *ngTemplateOutlet="steppers"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #defaultNav>
  <div class="sidebar" [class.has-sidebar]="sidebarState === sidebar.Default">
    <app-section-header class="sticky">{{
      title || 'GET STARTED'
    }}</app-section-header>
  </div>
</ng-template>

<ng-template #steppers>
  <div class="sidebar" [class.has-sidebar]="sidebarState === sidebar.Stepper">
    <ng-template #showTick>
      <img
        src="assets/icons/ic-tick-white@3x.svg"
        alt=""
        width="20"
        height="20"
      />
    </ng-template>
    <ul class="sticky">
      <li
        *ngFor="let stepper of stepperRoute"
        class="step"
        [class.current-step]="currentStep >= stepper.step"
      >
        <a [routerLink]="currentStep > stepper.step ? [stepper.fullPath] : []">
          <span class="stepper-circle">
            <span *ngIf="currentStep <= stepper.step; else showTick">{{
              stepper.step
            }}</span>
          </span>
          {{ stepper.title }}</a
        >
      </li>
    </ul>
  </div>
</ng-template>
